/* tslint:disable */

/**
 */
export class UserChangePassword {
    new_password?: string;
    confirm_password?: string;
    user_id?: number;
}
